import React from "react";

import CenteredLayout from "layouts/CenteredLayout";
import ForgotPasswordForm from "components/ForgotPasswordForm";

import { useAppMeta } from "hooks";

import banner from "assets/tmsnewpsd.png";

const ForgotPasswordScreen = () => {

  const { appMeta } = useAppMeta();

  useAppMeta("Forgot Password");
  const handleLogoClick = () => {
    window.location.href = "/home";
  };
  return (
 <CenteredLayout banner={banner}>
        <div className="text-center">
          <img
            src={appMeta.logoSmall}
            alt={appMeta.title}
            className="mx-auto mb-2 h-8 w-auto cursor-pointer"
            onClick={handleLogoClick}
          />
               </div>
        <ForgotPasswordForm />
      
    </CenteredLayout>
  );
};

export default ForgotPasswordScreen;
